import api from './api';

export const systemMonitoringService = {
    // Sistem sağlık durumunu getir
    fetchSystemHealthStatus: async () => {
        const response = await api.get('/admin/system-health');
        return response.data;
    },

    // Gelişmiş sistem metrikleri: bunun için henüz gerçek bir izleme entegrasyonu (backend
    // endpoint'i + OS seviyesinde metrik toplama) yok. Önceden bu alan Math.random() ile üretilmiş
    // sayılar gösteriyordu ve gerçek veri gibi sunuluyordu — yanıltıcıydı. Gerçek izleme
    // entegre edilene kadar `simulated: true` ile açıkça işaretlenmiş, boş (null) değerler
    // döndürüyoruz; UI bu bayrağa bakıp "henüz izlenmiyor" uyarısı gösteriyor.
    fetchAdvancedSystemMetrics: async () => {
        const now = new Date();
        return {
            success: true,
            simulated: true,
            data: {
                cpuUtilization: null,
                memoryUsage: null,
                swapUsage: null,
                systemLoad: null,
                diskUsage: null,
                diskIOPS: null,
                diskLatency: null,
                networkThroughput: null,
                networkPackets: null,
                tcpConnections: null,
                activeConnections: null,
                queryPerformance: null,
                bufferHitRatio: null,
                responseLatency: null,
                transactionRate: null,
                systemTemperature: null,
                simulated: true,
                timestamp: now.toISOString()
            }
        };
    },

    // Sistem durumunu yenile
    refreshSystemMonitoring: async () => {
        const [healthResponse, metricsResponse] = await Promise.all([
            systemMonitoringService.fetchSystemHealthStatus(),
            systemMonitoringService.fetchAdvancedSystemMetrics()
        ]);

        return {
            health: healthResponse,
            metrics: metricsResponse
        };
    },

    // Sağlık durumu hesapla
    calculateSystemHealthStatus: (healthData, metricsData) => {
        if (!healthData || !metricsData) return 'unknown';

        const { database, errors, activeUsers } = healthData;
        const { cpuUtilization, memoryUsage, diskUsage, responseLatency } = metricsData;

        // Kritik durumlar
        if (!database.healthy) return 'critical';
        if (cpuUtilization > 90 || memoryUsage > 90) return 'critical';

        // Performans düşüklüğü
        if (errors.length > 2 || responseLatency > 500) return 'degraded';
        if (cpuUtilization > 70 || memoryUsage > 80) return 'degraded';

        // Optimal durum
        return 'optimal';
    },

    // Metrik trend hesapla
    calculateMetricTrend: (current, previous) => {
        if (!previous) return 'stable';
        const change = ((current - previous) / previous) * 100;

        if (change > 10) return 'increasing';
        if (change < -10) return 'decreasing';
        return 'stable';
    }
};